export const OPTHINES = {
  voteName: '2019poject/2019shequn',
  buttonBg: '#d72620',
  mustSearch: 'Button',
  number: {
    mustRank: true,
  },
  name: true,
  content: true,
  user: true,
  themeColor: {
    activeBgColor: '#9a36a3',
    inactiveBgColor: '#f9f9f9',
  },
  tickets: {
    textFirst: '点赞数',
    textLast: '赞',
  },
  tabs: [
    {
      tabName: '社群首页',
      tabPath: '/2019AssociationEcologyMeeting/List',
    },
    {
      tabName: '活动规则',
      tabPath: '/2019AssociationEcologyMeeting/Rules',
    },
    {
      tabName: '相关新闻',
      tabPath: '/2019AssociationEcologyMeeting/NewsPage',
    },
    {
      tabName: '我要报名',
      tabPath: '/2019AssociationEcologyMeeting/Register',
    },
  ],
  Type: [
    '2019年度中国影响力社群',
    '2019年度重庆新锐社群',
    '重庆生活方式社群TOP榜',
    '重庆社群红人TOP榜',
  ],
};
